import axiosInstance from 'services/axiosMiddleware';

export async function updateApproveorRejectStatus({ asanaId, statusId, rejectionReason }) {
  try {
    const payload = {
      asanaId,
      statusId
    };

    // Include rejectionReason only when rejecting
    if (statusId === 2 && rejectionReason) {
      payload.rejectionReason = rejectionReason;
    }

    const response = await axiosInstance.post('admin/updatestatus', payload);

    if (response.data.status) {
      return response.data.message;
    } else {
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error('Error updating Asana:', error);
    throw error;
  }
}
